// extracted by mini-css-extract-plugin
export default {"main-container-flex":"channelPartner_main-container-flex__2I1IE","hBit_red_span":"channelPartner_hBit_red_span__26mAk","term-in-use":"channelPartner_term-in-use__2iuC7"};